import { RepositoryBuilder }       from 'alto-orm/lib/orm';
import FoodRepository, { Product } from 'alto-react-food/lib/models';

import { BillHeader, BillItem, BillPayment } from './bill';

const SKRepository = new RepositoryBuilder;

SKRepository.registerRelation(BillHeader,  '/sk/crud/bill_headers');
SKRepository.registerRelation(BillItem,    '/sk/crud/bill_items');
SKRepository.registerRelation(BillPayment, '/sk/crud/bill_payments');

SKRepository.registerHasMany(BillHeader, BillItem,    'items',    'headerID');
SKRepository.registerHasMany(BillHeader, BillPayment, 'payments', 'headerID');

SKRepository.registerBelongsTo(BillItem,    BillHeader, 'header', 'headerID', 'header');
SKRepository.registerBelongsTo(BillPayment, BillHeader, 'header', 'headerID', 'header');

SKRepository.registerAllFrom(FoodRepository);

SKRepository.registerBelongsTo(BillItem, Product);

export default SKRepository; // takes backendUrl and auth
